import { render, staticRenderFns } from "./popup-download-tips.vue?vue&type=template&id=4bc5929e&scoped=true"
import script from "./popup-download-tips.vue?vue&type=script&lang=ts"
export * from "./popup-download-tips.vue?vue&type=script&lang=ts"
import style0 from "./popup-download-tips.vue?vue&type=style&index=0&id=4bc5929e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5929e",
  null
  
)

export default component.exports